import CustomStyleSheet from '@prahatech/util-react-web/stylesheet/CustomStyleSheet';

const CONFIG = {
  color: {
    warn: '#FF9999',

    primary: '#3299FA',
    lightPrimary: '',
    lighterPrimary: '',

    secondary: '',
    lightSecondary: '',
    lighterSecondary: '',

    white: '#FFFFFF',
    opaqueWhite: '#FFFFFFE8',

    lightestGrey: '',
    lighterGrey: '#FEFEFE',
    lightGrey: '#DEDEDE',

    grey: '#AFAFAF',

    darkGrey: '#AAAAAA',
    darkerGrey: '#777777',
    darkestGrey: '',

    black: '#333333',

    transparent: '#FFFFFF00',
  },
  spacing: {
    smallest: '.5em',
    smaller: '1em',
    small: '1.5em',
    medium: '2em',
    large: '3em',
    larger: '4em',
    largest: '6em',
  },
};

function conf(category, property) {
  const unknown = `unknown[${category}.${property}]`;

  try {
    const prop = CONFIG[category][property];

    return String(prop) || unknown;
  } catch (e) {
    return unknown;
  }
}

CustomStyleSheet.defineGlobalFunction('conf', conf);
